<template>
  <div :id="id" class="container-fluid portada pt-4">
    <div v-show="editar">
      <!--Botones de Sección-->
      <div class="btn-edit-portada d-flex flex-column">
        <!--Boton de Editar Sección-->
        <b-dropdown
          id="dropdownu"
          right
          size="sm"
          text="Editar Portada"
          variant="dark"
          :class="{ ocultarClass: esHome }"
          class="mb-3"
        >
          <!-- Boton editar fondo -->
          <b-dropdown-item v-b-modal="'bgportada'">
            <font-awesome-icon icon="fill-drip" />Editar Fondo
          </b-dropdown-item>
          <!-- Botón editar layout -->
          <!--<b-dropdown-item v-b-modal="'modal-layouts'">
            <font-awesome-icon icon="object-group" />Cambiar Layout
          </b-dropdown-item>-->
        </b-dropdown>
      </div>
    </div>
    <!--Mes-->
    <div class="row d-flex flex-row mb-2 mt-5">
      <b-badge
        :class="{ ocultarClass: esHome }"
        class="clic"
        variant="info"
        v-on:click="toggleElement('portada0', route[0].state, 0)"
      >{{ message }}</b-badge>
      <div class="col-12 element elem-anim2 elem-anim" data-anim>
        <div id="portada0">
          <Texto :esHome="esHome" :online="online" :route="route[0]" />
        </div>
      </div>
    </div>
    <!-- Titulo -->
    <div class="row d-flex flex-row mb-2">
      <b-badge
        :class="{ ocultarClass: esHome }"
        class="clic"
        variant="info"
        v-on:click="toggleElement('portada1', route[1].state, 1)"
      >{{ message }}</b-badge>
      <div class="col-12 element elem-anim2 elem-anim" data-anim>
        <div id="portada1">
          <Texto :esHome="esHome" :online="online" :route="route[1]" />
        </div>
      </div>
    </div>
    <!-- Logo -->
    <div class="row pt-1 d-flex flex-row mb-2">
      <b-badge
        :class="{ ocultarClass: esHome }"
        class="clic"
        variant="info"
        v-on:click="toggleElement('portada2', route[2].state, 2)"
      >{{ message }}</b-badge>
      <div class="col-12 element elem-anim2 elem-anim" data-anim>
        <div id="portada2">
          <Imagen :esHome="esHome" :online="online" :route="route[2]" />
        </div>
      </div>
    </div>
    <!-- Audio -->
    <div class="row d-flex flex-row mb-2 audio">
      <b-badge
        :class="{ ocultarClass: esHome }"
        class="clic"
        variant="info"
        v-on:click="toggleElement('portada3', route[3].state, 3)"
      >{{ message }}</b-badge>
      <div class="col-12 element elem-anim2 elem-anim" data-anim>
        <div id="portada3">
          <Audio :esHome="esHome" :online="online" :route="route[3]" />
        </div>
      </div>
    </div>

    <!--Modal cambia el fondo de la sección-->
    <b-modal
      id="bgportada"
      ref="bgportada"
      size="sm"
      title="Cambiar fondo"
      @ok="handleOk"
      no-close-on-backdrop
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <!--Color sólido de fondo-->
        <!--<label class="text-dark" for="favcolor">Color de Fondo:</label>
        <div class="d-flex">
        <b-form-input ref="color" type="color" id="favcolor" name="favcolor" ></b-form-input>
        </div>-->
        <!--Escoger imagen-->
        <b-form-file
          size="sm"
          accept="image/*"
          browse-text="Abrir"
          placeholder="Imagen"
          :file-name-formatter="setBG"
        ></b-form-file>
        <img ref="myBG" class="w-50" />
        <!--Posición del fondo-->
        <b-form-group class="d-flex">
          <p class="my-2 text-dark">Posición del fondo</p>
          <div class="d-flex flex-wrap">
            <b-form-radio v-model="bg_position" name="center" value="center" class="m-1">Centrar</b-form-radio>
            <b-form-radio v-model="bg_position" name="cover" value="cover" class="m-1">Cubrir</b-form-radio>
            <b-form-radio v-model="bg_position" name="contain" value="contain" class="m-1">Contener</b-form-radio>
          </div>
        </b-form-group>
        <!--Fondo se repite-->
        <b-form-group class="d-flex">
          <p class="text-dark my-2">Repetir fondo</p>
          <div class="d-flex flex-wrap">
            <b-form-radio
              v-model="bg_repeat"
              name="no-repeat"
              value="no-repeat"
              class="m-2"
            >No repetir</b-form-radio>
            <b-form-radio v-model="bg_repeat" name="repeat" value="repeat" class="m-2">Repetir</b-form-radio>
          </div>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button size="sm" variant="success" @click="ok()">Guardar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Logo from '@/assets/logo.png'
import Texto from '@/components/atomos/Texto.vue'
import Imagen from '@/components/atomos/Imagen.vue'
import Audio from '@/components/atomos/Audio.vue'
import firebase from 'firebase'

export default {
  name: 'Portada',
  components: { Texto, Imagen, Audio },
  props: {
    titulo: String,
    esHome: Boolean,
    online: Boolean
  },
  data() {
    return {
      editar: true,
      Logo: Logo,
      id: 'portada',
      stateBtn: 'danger',
      localRoot: [],
      bg_position: 'cover',
      bg_repeat: 'no-repeat',
      bgcolor: '#ffffff',
      nameBG: '',
      message: 'mostrar/ocultar',
      fileName: null,
      route: [
        {
          name: 'portada',
          index: 0,
          state: 1
        },
        {
          name: 'portada',
          index: 1,
          state: 1
        },
        {
          name: 'portada',
          index: 2,
          state: 1
        },
        {
          name: 'portada',
          index: 3,
          state: 1
        }
      ]
    }
  },
  created() {
    // let object['id_portada'] = 'porada_1'
    // let root = JSON.parse(window.localStorage.getItem('root'))
    // const obj = {}
    // obj.name = 'portada'
    // obj.id = '01_portada'
    // root.push(obj)
    // console.log(root.fecha)
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    if (this.online) {
      this.nameBG = this.localRoot['componentes']['portada'][4]['bg-img']['url']
    } else {
      this.nameBG = this.localRoot['componentes']['portada'][4]['bg-img'][
        'name'
      ]
    }
    this.bg_position = this.localRoot['componentes']['portada'][4][
      'bg-position'
    ]
    this.bg_repeat = this.localRoot['componentes']['portada'][4]['bg-repeat']
    this.bgcolor = this.localRoot['componentes']['portada'][4]['bg-color']
  },
  mounted() {
    let section = document.getElementById(this.id)
    if (this.online) {
      section.style.backgroundImage = 'url(' + this.nameBG + ')'
    } else {
      section.style.backgroundImage = 'url(' + 'imgs/' + this.nameBG + ')'
    }
    section.style.backgroundSize = this.bg_position
    section.style.backgroundRepeat = this.bg_repeat
    section.style.backgroundColor = this.bgcolor

    let portadas = document.getElementsByClassName('elem-anim2')
    for (var k = 0; k < 4; k++) {
      if (this.localRoot['componentes']['portada'][k]['state'] == 0) {
        //console.log('entre')
        portadas[k].style.visibility = 'hidden'
        portadas[k].style.backgroundColor = 'transparent'
      } else if (this.localRoot['componentes']['portada'][k]['state'] == 1) {
        portadas[k].style.visibility = 'visible'
      }
      portadas[k].dataset.anim = this.localRoot['componentes']['portada'][k][
        'animation'
      ]
    }

    //let itemBG = this.$refs.myBG
    //itemBG.src = this.nameBG
    let elementos = document.getElementsByClassName('elem-anim2')
    for (var i = 0; i < 4; i++) {
      switch (this.localRoot['componentes']['portada'][i]['animation']) {
        case 'rl':
          elementos[i].classList.add('animation-slide-r-l')
          break

        case 'lr':
          elementos[i].classList.add('animation-slide-l-r')

          break

        case 'bounce':
          elementos[i].classList.add('animation-bounce')
          //console.log(elementos[element].dataset.sub)
          break
        case 'fade':
          elementos[i].classList.add('animation-bounce')
          //console.log(elementos[element].dataset.sub)
          break
        default:
          elementos[i].classList.add('animation-slide-l-r')
          //console.log('el default')
          break
      }
    }
  },
  methods: {
    handler(component) {
      console.log('this component is showing' + component)
    },
    handleOk() {
      this.handleSubmit()
    },
    handleSubmit() {
      //let color = this.$refs.color.value
      //this.bgcolor = color
      let master = document.getElementById(this.id)
      //master.style.backgroundColor = color
      if (this.bg_position === 'center') {
        master.style.backgroundPosition = 'center'
      } else master.style.backgroundSize = this.bg_position
      master.style.backgroundRepeat = this.bg_repeat

      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['portada'][4][
        'bg-position'
      ] = this.bg_position
      this.localRoot['componentes']['portada'][4]['bg-repeat'] = this.bg_repeat
      //this.localRoot['componentes']['portada'][4]['bg-color'] = this.bgcolor
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id + this.typeModal)
      })
    },
    setBG(file) {
      /*this.nameBG = 'imgs/' + file[0].name
      let itemBG = this.$refs.myBG
      itemBG.src = this.nameBG
      let section = document.getElementById(this.id)
      section.style.backgroundImage = 'url(' + this.nameBG + ')'
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['portada'][4]['bg-img'] = this.nameBG
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      */
      this.fileName = file[0].name
      if (file.length === 1) {
        let locationStorage = '/imagenes/'
        let storageRef = firebase.storage().ref(locationStorage + file[0].name)
        let uploadTask = storageRef.put(file[0])

        uploadTask.on(
          'state_changed',
          snapshot => {
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running')
                break
            }
          },
          error => {
            console.log(error)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.firebaseURL = downloadURL

              let section = document.getElementById(this.id)
              section.style.backgroundImage = 'url(' + this.firebaseURL + ')'
              this.localRoot = JSON.parse(window.localStorage.getItem('root'))
              this.localRoot['componentes']['portada'][4]['bg-img'][
                'name'
              ] = this.fileName
              this.localRoot['componentes']['portada'][4]['bg-img'][
                'url'
              ] = downloadURL
              let parsedRoot = JSON.stringify(this.localRoot)
              window.localStorage.setItem('root', parsedRoot)

              //alert('La imagen se ha subido!')
              // Obtengo el elemento DOM de la imagen
              let itemBG = this.$refs.myBG
              itemBG.src = this.firebaseURL
            })
          }
        )
      } else {
        return alert('Solo se puede subir una imagen')
      }
    },
    toggleElement(id, action, index) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (action === 1) {
        let element = document.getElementById(id)
        element.style.visibility = 'hidden'
        element.style.backgroundColor = 'transparent'
        this.route[index].state = 0
        this.localRoot['componentes']['portada'][index]['state'] = 0
        console.log('ocultar')
      } else {
        console.log('mostrar')
        let element = document.getElementById(id)
        element.style.visibility = 'visible'
        this.route[index].state = 1
        this.localRoot['componentes']['portada'][index]['state'] = 1
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    showElement(id) {
      let element = document.getElementById(id)
      element.style.display = 'block'
    }
  }
}
</script>

<style lang="scss" scoped>
$myvar: #6244e6;

.btn-edit-portada {
  top: -10px;
  right: 0px;
  position: absolute;
  z-index: 100;
}

p {
  color: aliceblue;
}
.audio-item {
  width: 100%;
  max-width: 20em;
}

.portada {
  min-height: 100vh;
}

#portada3 {
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}

.elem-anim2 {
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
  opacity: 0;
}

#portada0 {
  margin-left: 120px;
}

.audio {
  position: absolute;
  bottom: 0;
  width: 90%;
}
</style>
